module.exports = __webpack_public_path__ + "static/gq-spend-get-dec-web-if-offers-banner-mobile-gfnz-db39e5a17ea33aee2956634223dd6c15.webp";